import i18next, { t } from 'i18next';
import '../../components/NotFoundComponent/NotFoundSection.scss';
import { useNavigate } from 'react-router-dom';

const UnAuthorized = () => {
  const navigate = useNavigate()
  return (
    <>

      <section className='not-aut'>
        <div className='header-anot pt-3 pb-3'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12 d-flex justify-content-between'>
                <div 
                onClick={() => 
                  navigate('/')
                } 
                className="niit-lgo cursor-pointer"><svg width="212" height="48" viewBox="0 0 212 48" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M77.66 33.124H84.629V42.002H81.662L81.386 40.484C80.8647 41.1126 80.19 41.565 79.362 41.841C78.5493 42.1016 77.6907 42.232 76.786 42.232C75.1607 42.232 73.75 41.91 72.554 41.266C71.3733 40.622 70.4533 39.702 69.794 38.506C69.15 37.2946 68.828 35.8456 68.828 34.159C68.828 32.4416 69.196 30.9313 69.932 29.628C70.6833 28.3093 71.7413 27.282 73.106 26.546C74.4707 25.81 76.073 25.442 77.913 25.442C79.4617 25.442 80.765 25.718 81.823 26.27C82.8963 26.8066 83.7933 27.627 84.514 28.731L81.639 30.824C81.2557 30.134 80.7267 29.6356 80.052 29.329C79.3773 29.007 78.6643 28.846 77.913 28.846C76.8397 28.846 75.9197 29.0683 75.153 29.513C74.3863 29.9423 73.7883 30.5556 73.359 31.353C72.945 32.135 72.738 33.0473 72.738 34.09C72.738 35.608 73.1367 36.781 73.934 37.609C74.7313 38.437 75.8277 38.851 77.223 38.851C77.775 38.851 78.327 38.759 78.879 38.575C79.431 38.3756 79.8987 38.0766 80.282 37.678C80.6807 37.2793 80.9183 36.781 80.995 36.183H77.66V33.124ZM92.7843 42.232C91.481 42.232 90.354 41.9943 89.4033 41.519C88.4526 41.0283 87.7166 40.346 87.1953 39.472C86.674 38.5826 86.4133 37.5323 86.4133 36.321C86.4133 35.0943 86.674 34.0133 87.1953 33.078C87.732 32.1426 88.445 31.4143 89.3343 30.893C90.239 30.3716 91.2586 30.111 92.3933 30.111C93.6813 30.111 94.7316 30.4023 95.5443 30.985C96.357 31.5676 96.9166 32.3956 97.2233 33.469C97.5453 34.527 97.6143 35.7613 97.4303 37.172H90.0013C90.0933 37.7546 90.4 38.2453 90.9213 38.644C91.4426 39.0273 92.1556 39.219 93.0603 39.219C93.4743 39.219 93.9113 39.1346 94.3713 38.966C94.8313 38.782 95.2223 38.5136 95.5443 38.161L97.4993 40.231C96.9933 40.8443 96.3646 41.335 95.6133 41.703C94.8773 42.0556 93.9343 42.232 92.7843 42.232ZM92.4623 32.664C91.849 32.664 91.3276 32.848 90.8983 33.216C90.4843 33.584 90.2083 34.0976 90.0703 34.757H94.4633C94.4786 34.0363 94.3023 33.5073 93.9343 33.17C93.5816 32.8326 93.091 32.664 92.4623 32.664ZM99.5894 42.002V30.295H103.085L102.924 32.802C103.4 31.9433 104.005 31.284 104.741 30.824C105.493 30.3486 106.328 30.111 107.248 30.111C108.644 30.111 109.686 30.5863 110.376 31.537C111.066 32.4723 111.404 33.8216 111.388 35.585L111.342 42.002H107.823L107.869 35.838C107.885 35.0406 107.762 34.435 107.501 34.021C107.256 33.5916 106.857 33.377 106.305 33.377C105.845 33.377 105.424 33.515 105.04 33.791C104.657 34.0516 104.32 34.504 104.028 35.148C103.752 35.792 103.53 36.6736 103.361 37.793C103.193 38.9123 103.101 40.3153 103.085 42.002H99.5894ZM112.01 42.002L119.095 25.672H122.246L129.054 42.002H125.235L123.925 38.667H117.186L115.829 42.002H112.01ZM118.473 35.539H122.683L120.613 30.272L118.473 35.539ZM130.141 42.002V25.672H133.89V42.002H130.141ZM148.054 42.209C146.045 42.209 144.489 41.7796 143.385 40.921C142.281 40.0623 141.652 38.7973 141.499 37.126L145.018 36.62C145.11 37.4173 145.424 38.0306 145.961 38.46C146.497 38.874 147.241 39.081 148.192 39.081C149.004 39.081 149.625 38.943 150.055 38.667C150.499 38.3756 150.722 37.9693 150.722 37.448C150.722 36.9726 150.492 36.597 150.032 36.321C149.572 36.045 148.813 35.7843 147.755 35.539C146.62 35.263 145.662 34.9333 144.88 34.55C144.098 34.1513 143.507 33.6376 143.109 33.009C142.71 32.3803 142.511 31.583 142.511 30.617C142.511 29.605 142.771 28.708 143.293 27.926C143.814 27.144 144.542 26.5383 145.478 26.109C146.413 25.6643 147.494 25.442 148.721 25.442C150.315 25.442 151.619 25.8483 152.631 26.661C153.643 27.4736 154.225 28.5853 154.379 29.996L151.09 30.548C150.967 29.9193 150.683 29.4363 150.239 29.099C149.794 28.7463 149.234 28.57 148.56 28.57C147.885 28.57 147.341 28.731 146.927 29.053C146.513 29.3596 146.306 29.7813 146.306 30.318C146.306 30.8086 146.505 31.2073 146.904 31.514C147.302 31.8053 148.031 32.0813 149.089 32.342C150.208 32.618 151.174 32.9323 151.987 33.285C152.799 33.6223 153.42 34.09 153.85 34.688C154.294 35.286 154.517 36.0986 154.517 37.126C154.517 38.1226 154.248 39.0043 153.712 39.771C153.175 40.5376 152.416 41.1356 151.435 41.565C150.469 41.9943 149.342 42.209 148.054 42.209ZM161.166 42.232C159.725 42.232 158.582 41.8333 157.739 41.036C156.896 40.2233 156.482 39.1576 156.497 37.839L156.589 33.216H154.657V30.295H156.635L156.658 27.903H160.154L160.131 30.295H163.788V33.216H160.085L160.016 37.448C160.016 38 160.162 38.4293 160.453 38.736C160.744 39.0426 161.181 39.196 161.764 39.196C162.101 39.196 162.423 39.1576 162.73 39.081C163.052 38.989 163.382 38.8203 163.719 38.575L164.731 41.266C163.949 41.91 162.761 42.232 161.166 42.232ZM169.489 42.232C168.139 42.232 167.12 41.772 166.43 40.852C165.74 39.932 165.402 38.6516 165.418 37.011L165.464 30.295H168.983L168.937 36.735C168.937 37.425 169.059 37.9693 169.305 38.368C169.55 38.7666 169.933 38.966 170.455 38.966C170.899 38.966 171.306 38.828 171.674 38.552C172.042 38.276 172.364 37.816 172.64 37.172C172.916 36.528 173.13 35.6463 173.284 34.527C173.452 33.4076 173.544 31.997 173.56 30.295H176.964V42.002H173.445L173.606 39.748C173.146 40.5453 172.563 41.1586 171.858 41.588C171.152 42.0173 170.363 42.232 169.489 42.232ZM191.163 24.982V42.002H187.621L187.736 40.277C186.892 41.5803 185.643 42.232 183.987 42.232C182.944 42.232 182.055 41.9943 181.319 41.519C180.583 41.0436 180.023 40.3843 179.64 39.541C179.256 38.6976 179.065 37.7316 179.065 36.643C179.065 35.3396 179.333 34.1973 179.87 33.216C180.406 32.2346 181.127 31.4756 182.032 30.939C182.936 30.387 183.948 30.111 185.068 30.111C185.589 30.111 186.072 30.1876 186.517 30.341C186.961 30.4943 187.345 30.709 187.667 30.985L187.644 30.295V24.982H191.163ZM185.413 33.17C184.569 33.17 183.902 33.4843 183.412 34.113C182.936 34.7416 182.699 35.5466 182.699 36.528C182.699 37.3713 182.883 38.023 183.251 38.483C183.634 38.943 184.148 39.173 184.792 39.173C185.574 39.173 186.241 38.851 186.793 38.207C187.36 37.563 187.644 36.7196 187.644 35.677C187.644 34.895 187.444 34.2816 187.046 33.837C186.647 33.3923 186.103 33.17 185.413 33.17ZM197.399 30.295V42.002H193.88V30.295H197.399ZM195.628 28.915C194.954 28.915 194.417 28.708 194.018 28.294C193.62 27.88 193.42 27.3893 193.42 26.822C193.42 26.2546 193.612 25.764 193.995 25.35C194.394 24.936 194.938 24.729 195.628 24.729C196.303 24.729 196.84 24.936 197.238 25.35C197.637 25.764 197.836 26.2546 197.836 26.822C197.836 27.3893 197.637 27.88 197.238 28.294C196.84 28.708 196.303 28.915 195.628 28.915ZM205.807 30.111C207.631 30.111 209.057 30.6323 210.085 31.675C211.127 32.7176 211.649 34.1283 211.649 35.907C211.649 37.1183 211.388 38.1993 210.867 39.15C210.345 40.1006 209.609 40.852 208.659 41.404C207.708 41.956 206.589 42.232 205.301 42.232C203.491 42.232 202.065 41.7106 201.023 40.668C199.995 39.6253 199.482 38.2223 199.482 36.459C199.482 35.2323 199.742 34.1436 200.264 33.193C200.785 32.2423 201.521 31.491 202.472 30.939C203.422 30.387 204.534 30.111 205.807 30.111ZM205.462 39.173C206.244 39.173 206.865 38.8816 207.325 38.299C207.8 37.701 208.038 36.9036 208.038 35.907C208.038 35.0483 207.831 34.3813 207.417 33.906C207.003 33.4153 206.435 33.17 205.715 33.17C204.917 33.17 204.281 33.469 203.806 34.067C203.346 34.6496 203.116 35.4393 203.116 36.436C203.116 37.2946 203.315 37.9693 203.714 38.46C204.128 38.9353 204.71 39.173 205.462 39.173Z"
                    fill="#002346"></path>
                  <path
                    d="M68 3.00195H73.0092C73.7541 4.74753 74.4833 6.50031 75.2223 8.24785C75.2643 7.39933 75.2511 6.54818 75.238 5.699C75.1659 5.27277 74.661 5.13704 74.2885 5.14294C74.2695 4.43015 74.2918 3.7154 74.2833 3.00195H79.0125C79.0125 3.72326 79.0144 4.44458 79.0079 5.16523C78.6223 5.15081 78.0898 5.30228 78.0466 5.7554C78.0407 8.68458 78.0393 11.6138 78.0407 14.5429C78.0439 14.6964 78.0466 14.8511 78.0125 15.002H74.1436C74.0387 14.8813 73.998 14.7246 73.9357 14.581C73.2184 12.8413 72.4813 11.1095 71.781 9.36326C71.7449 10.3383 71.7561 11.3147 71.7685 12.2892C71.8597 12.7036 72.3469 12.8177 72.7134 12.8183C72.7062 13.5462 72.7305 14.2747 72.697 15.002H68V12.819C68.4492 12.9029 69.0374 12.5698 68.9541 12.0524C68.9502 9.95277 68.9561 7.85244 68.9508 5.75212C68.9102 5.3049 68.3816 5.15081 68 5.16982V3.00195Z"
                    fill="#002346"></path>
                  <path
                    d="M79.4866 3.00195H84.6978C84.6965 3.7272 84.7043 4.45179 84.7017 5.17703C84.3017 5.16261 83.745 5.339 83.7358 5.81835C83.7312 7.91933 83.7332 10.021 83.7345 12.1226C83.7233 12.6242 84.2932 12.8308 84.7128 12.819C84.7076 13.5469 84.7247 14.2747 84.6971 15.002H79.5102C79.4722 14.2839 79.5063 13.5639 79.4925 12.8446C79.7942 12.817 80.1358 12.7744 80.3443 12.5285C80.4774 12.379 80.4551 12.1692 80.4558 11.9849C80.4532 9.99671 80.4538 8.00851 80.4591 6.02031C80.4584 5.8354 80.4715 5.62884 80.343 5.47802C80.1528 5.20458 79.7883 5.18228 79.4866 5.15212C79.486 4.4354 79.4866 3.71867 79.4866 3.00195Z"
                    fill="#002346"></path>
                  <path
                    d="M85.1849 3.00195H90.3921C90.3915 3.72654 90.3928 4.45179 90.3915 5.17638C90.017 5.17769 89.4859 5.3049 89.4426 5.75146C89.44 7.91933 89.4315 10.0872 89.4479 12.2544C89.5128 12.6846 90.0203 12.8118 90.3908 12.8144C90.4013 13.5429 90.398 14.2728 90.3902 15.002H85.2203C85.1705 14.2806 85.2105 13.5567 85.1921 12.8341C85.5705 12.8367 86.101 12.7003 86.1423 12.2505C86.1462 10.0859 86.1495 7.9213 86.1403 5.75671C86.1082 5.29572 85.5665 5.15408 85.1836 5.15081C85.1862 4.43474 85.1842 3.71802 85.1849 3.00195Z"
                    fill="#002346"></path>
                  <path
                    d="M90.8926 3.00195H100.786V7.91999C99.9582 7.91933 99.13 7.92064 98.3024 7.91933C98.3004 7.26425 98.3057 6.60917 98.3004 5.95474C98.2827 5.69966 98.1463 5.35474 97.8414 5.3613C97.6093 5.40982 97.5123 5.6754 97.5227 5.88851C97.526 7.91933 97.5188 9.94949 97.5182 11.9803C97.5175 12.1626 97.4985 12.3698 97.6329 12.5147C97.8368 12.7515 98.1686 12.7974 98.4631 12.819C98.4611 13.5469 98.4736 14.2747 98.4559 15.002H93.2834C93.2532 14.2813 93.2723 13.5593 93.2618 12.838C93.5634 12.8197 93.9063 12.7731 94.1096 12.522C94.2552 12.3541 94.2126 12.1213 94.2178 11.918C94.2237 9.90622 94.2218 7.89441 94.2204 5.88261C94.2329 5.67081 94.1339 5.4013 93.9018 5.35933C93.5818 5.34818 93.4178 5.70228 93.4106 5.97703C93.4041 6.62556 93.4086 7.27474 93.4027 7.92392C92.566 7.92851 91.7293 7.91802 90.8926 7.9154C90.8926 6.27736 90.8926 4.63999 90.8926 3.00195Z"
                    fill="#002346"></path>
                  <path
                    d="M40.5009 33.3777C39.2544 33.3807 38.1039 33.7932 37.1784 34.4862L37.1934 34.4757L32.2449 29.9787C33.4749 28.3332 34.2144 26.2602 34.2144 24.0132C34.2144 21.5922 33.3564 19.3722 31.9269 17.6397L31.9404 17.6562L37.4064 12.1917C38.2824 12.7782 39.3594 13.1277 40.5174 13.1277C43.6329 13.1277 46.1574 10.6032 46.1574 7.48766C46.1574 4.37216 43.6329 1.84766 40.5174 1.84766C37.4019 1.84766 34.8774 4.37216 34.8774 7.48766C34.8774 8.64716 35.2269 9.72416 35.8269 10.6197L35.8134 10.5987L30.3489 16.0632C28.6314 14.6472 26.4084 13.7877 23.9829 13.7877C22.5774 13.7877 21.2409 14.0757 20.0259 14.5977L20.0919 14.5722L18.5439 11.7612C19.7304 10.7292 20.4759 9.21866 20.4759 7.53266C20.4759 4.44266 17.9709 1.93916 14.8824 1.93916C11.7939 1.93916 9.28889 4.44416 9.28889 7.53266C9.28889 10.6227 11.7939 13.1262 14.8824 13.1262C14.8929 13.1262 14.9049 13.1262 14.9154 13.1262C15.5124 13.1172 16.0809 13.0167 16.6134 12.8352L16.5744 12.8472L18.1299 15.6717C15.4944 17.5362 13.7949 20.5692 13.7889 24.0012V24.0027C13.8039 25.0482 13.9764 26.0487 14.2839 26.9877L14.2644 26.9172L12.1299 27.8217C11.1084 26.3652 9.43739 25.4262 7.54589 25.4262C4.46189 25.4262 1.96289 27.9252 1.96289 31.0092C1.96289 34.0932 4.46189 36.5922 7.54589 36.5922C10.6299 36.5922 13.1289 34.0932 13.1289 31.0092C13.1289 30.6132 13.0884 30.2277 13.0104 29.8557L13.0164 29.8917L15.1449 28.9887C16.8954 32.1282 20.1954 34.2162 23.9829 34.2162C26.5779 34.2162 28.9449 33.2352 30.7329 31.6242L30.7239 31.6317L35.6874 36.1422C35.1849 36.9582 34.8849 37.9437 34.8789 39.0012C34.8789 42.1077 37.3974 44.6277 40.5039 44.6277C43.6104 44.6277 46.1289 42.1092 46.1289 39.0027C46.1289 35.8962 43.6104 33.3777 40.5039 33.3777H40.5009ZM11.5359 7.50266C11.5359 5.63816 13.0464 4.12766 14.9109 4.12766C16.7754 4.12766 18.2859 5.63816 18.2859 7.50266C18.2859 9.36716 16.7754 10.8777 14.9109 10.8777C13.0479 10.8747 11.5389 9.36566 11.5359 7.50266ZM7.50089 34.3827C5.63789 34.3812 4.12889 32.8722 4.12889 31.0092C4.12889 29.1462 5.63939 27.6357 7.50239 27.6357C9.36539 27.6357 10.8744 29.1447 10.8759 31.0077C10.8729 32.8707 9.36389 34.3797 7.50089 34.3827ZM40.5009 4.12766C42.3654 4.12766 43.8759 5.63816 43.8759 7.50266C43.8759 9.36716 42.3654 10.8777 40.5009 10.8777C38.6364 10.8777 37.1259 9.36716 37.1259 7.50266C37.1289 5.63966 38.6379 4.13066 40.5009 4.12766ZM16.0359 24.0027C16.0359 24.0027 16.0359 24.0027 16.0359 24.0012C16.0359 19.6032 19.6014 16.0377 23.9994 16.0377C28.3974 16.0377 31.9629 19.6032 31.9629 24.0012C31.9629 28.3992 28.3974 31.9647 23.9994 31.9647C19.6029 31.9602 16.0419 28.3977 16.0359 24.0027ZM40.5009 42.3777C38.6364 42.3777 37.1259 40.8672 37.1259 39.0027C37.1259 37.1382 38.6364 35.6277 40.5009 35.6277C42.3654 35.6277 43.8759 37.1382 43.8759 39.0027C43.8729 40.8657 42.3639 42.3747 40.5009 42.3777Z"
                    fill="#002346"></path>
                </svg></div>
                <div 
                onClick={() => 
                  navigate('/')
                } 
                className='homebntn d-flex align-items-center gap-2 cursor-pointer'><img src="/images/home.svg" alt="Home" width="24" height="24" />Home</div>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <section className='not-found d-flex align-items-center justify-content-center flex-wrap gap-5'>
            <div className='not-found-img'>
              <svg
                width='403'
                height='300'
                viewBox='0 0 403 300'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M402.624 263.637H0V263.836H402.624V263.637Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M362.278 276.594H335.609V276.793H362.278V276.594Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M266.712 278.785H259.715V278.985H266.712V278.785Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M334.807 269.119H319.352V269.319H334.807V269.119Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M77.0233 270.473H42.2422V270.672H77.0233V270.473Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M89.2934 270.473H84.1953V270.672H89.2934V270.473Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M181.298 273.871H105.863V274.071H181.298V273.871Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M190.842 227.726H35.3564C34.1381 227.723 32.9707 227.237 32.1107 226.374C31.2506 225.511 30.7682 224.342 30.7695 223.124V4.55763C30.7798 3.34699 31.2673 2.18927 32.1261 1.33593C32.9849 0.482586 34.1457 0.00252156 35.3564 0H190.842C192.061 -6.82812e-07 193.231 0.484126 194.094 1.34601C194.956 2.2079 195.442 3.37705 195.443 4.59658V223.124C195.443 224.344 194.958 225.515 194.095 226.378C193.232 227.241 192.062 227.726 190.842 227.726ZM35.3564 0.160686C34.1941 0.160686 33.0794 0.622394 32.2576 1.44424C31.4358 2.26609 30.974 3.38075 30.974 4.54302V223.124C30.974 224.286 31.4358 225.401 32.2576 226.223C33.0794 227.045 34.1941 227.506 35.3564 227.506H190.842C192.004 227.506 193.119 227.045 193.94 226.223C194.762 225.401 195.224 224.286 195.224 223.124V4.55763C195.224 3.39536 194.762 2.2807 193.94 1.45885C193.119 0.637003 192.004 0.175294 190.842 0.175294L35.3564 0.160686Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M365.025 227.726H209.535C208.315 227.723 207.147 227.237 206.284 226.375C205.422 225.513 204.936 224.344 204.934 223.124V4.55763C204.948 3.34565 205.438 2.18796 206.3 1.33501C207.161 0.482072 208.323 0.00247804 209.535 0H365.025C366.235 0.00380145 367.395 0.484431 368.252 1.33764C369.11 2.19085 369.597 3.34783 369.607 4.55763V223.124C369.607 224.341 369.125 225.509 368.266 226.371C367.408 227.233 366.242 227.72 365.025 227.726ZM209.535 0.160686C208.373 0.160686 207.258 0.622394 206.436 1.44424C205.614 2.26609 205.153 3.38075 205.153 4.54302V223.124C205.153 224.286 205.614 225.401 206.436 226.223C207.258 227.045 208.373 227.506 209.535 227.506H365.025C366.187 227.506 367.302 227.045 368.124 226.223C368.946 225.401 369.407 224.286 369.407 223.124V4.55763C369.407 3.39536 368.946 2.2807 368.124 1.45885C367.302 0.637003 366.187 0.175294 365.025 0.175294L209.535 0.160686Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M175.907 185.908H74.1055V193.09H175.907V185.908Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M175.907 185.908H131.641V193.09H175.907V185.908Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M89.1466 193.09H74.1055V263.636H89.1466V193.09Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M89.1466 200.369L74.1055 195.247V193.09H89.1466V200.369Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M175.901 193.09H160.859V263.636H175.901V193.09Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M146.682 193.09H131.641V263.636H146.682V193.09Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M146.677 200.369L131.641 195.247V193.09H146.677V200.369Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M118.365 193.09H103.324V263.636H118.365V193.09Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M185.472 25.9043H57.1719V135.151H185.472V25.9043Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M186.9 25.8945H185.469V135.141H186.9V25.8945Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M180.651 30.7246H62.0117V130.311H180.651V30.7246Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M119.891 115.212C127.141 91.0559 129.142 55.4227 144.563 60.3358C159.984 65.2488 139.791 117.934 139.791 117.934L119.891 115.212Z'
                  fill='white'
                />
                <path
                  d='M132.342 116.399C124.966 81.3846 126.826 34.9075 103.911 35.969C80.9962 37.0305 103.911 117.919 103.911 117.919L132.342 116.399Z'
                  fill='white'
                />
                <path
                  d='M148.537 112.471H98.3834C97.359 112.435 96.3618 112.805 95.608 113.499C94.8542 114.194 94.4045 115.158 94.3565 116.181C93.3339 139.291 97.1174 162.887 104.168 185.909H142.587C149.632 162.844 153.416 139.291 152.393 116.181C152.353 115.185 151.929 114.243 151.211 113.551C150.492 112.86 149.534 112.473 148.537 112.471Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M262.668 38.0879H259.844V263.637H262.668V38.0879Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M329.094 38.0879H326.27V263.637H329.094V38.0879Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M242.625 38.0879H239.801V263.637H242.625V38.0879Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M309.051 38.0879H306.227V263.637H309.051V38.0879Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 36.5391H239.801V39.6213H329.093V36.5391Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 91.7715H239.801V94.8537H329.093V91.7715Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 147.004H239.801V150.086H329.093V147.004Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 202.234H239.801V205.317H329.093V202.234Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 257.467H239.801V260.549H329.093V257.467Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M329.093 36.5391H309.051V39.6213H329.093V36.5391Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M329.093 91.7715H309.051V94.8537H329.093V91.7715Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M329.093 147.004H309.051V150.086H329.093V147.004Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M329.093 202.234H309.051V205.317H329.093V202.234Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M329.093 257.467H309.051V260.549H329.093V257.467Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M275.82 55.3189V50.9707H265.108V55.3189C265.108 56.6818 264.567 57.989 263.604 58.9531C262.641 59.9173 261.334 60.4596 259.971 60.4609C258.608 60.4609 257.3 61.0018 256.335 61.9649C255.37 62.928 254.827 64.2346 254.824 65.598V91.7848H286.095V65.6077C286.092 64.2444 285.549 62.9378 284.584 61.9746C283.619 61.0115 282.311 60.4706 280.948 60.4706C279.585 60.4668 278.279 59.922 277.318 58.956C276.356 57.99 275.818 56.6818 275.82 55.3189Z'
                  fill='#F0F0F0'
                />
                <path
                  d='M298.038 129.051H250.996V147.013H298.038V129.051Z'
                  fill='#F0F0F0'
                />
                <path
                  d='M306.229 129.041H298.039V147.004H306.229V129.041Z'
                  fill='#E6E6E6'
                />
                <path
                  d='M306.229 137.035H298.039V139.017H306.229V137.035Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M298.038 137.035H250.996V139.017H298.038V137.035Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M285.435 225.709H248.691V257.466H285.435V225.709Z'
                  fill='#F0F0F0'
                />
                <path
                  d='M291.831 225.719H285.438V257.476H291.831V225.719Z'
                  fill='#E6E6E6'
                />
                <path
                  d='M291.831 239.84H285.438V243.341H291.831V239.84Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M285.435 239.84H248.691V243.341H285.435V239.84Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M291.831 236.139H285.438V237.385H291.831V236.139Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M285.435 236.139H248.691V237.385H285.435V236.139Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M257.648 169.947H250.996V202.24H257.648V169.947Z'
                  fill='#F0F0F0'
                />
                <path
                  d='M257.648 181.453H250.996V190.729H257.648V181.453Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M280.276 169.957H257.648V202.25H280.276V169.957Z'
                  fill='#E6E6E6'
                />
                <path
                  d='M267.92 165.773H260.406V202.234H267.92V165.773Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M267.92 177.363H260.406V182.978H267.92V177.363Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M267.92 186.736H260.406V192.351H267.92V186.736Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M293.479 165.773H267.93V202.234H293.479V165.773Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M276.286 169.947H272.234V202.24H276.286V169.947Z'
                  fill='#F0F0F0'
                />
                <path
                  d='M275.592 174.037H272.934V198.145H275.592V174.037Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M290.042 169.957H276.281V202.25H290.042V169.957Z'
                  fill='#E6E6E6'
                />
                <path
                  d='M287.1 168.248H282.527V202.235H287.1V168.248Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M287.1 179.047H282.527V184.281H287.1V179.047Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M287.1 187.793H282.527V193.027H287.1V187.793Z'
                  fill='#FAFAFA'
                />
                <path
                  d='M302.644 168.248H287.102V202.235H302.644V168.248Z'
                  fill='#E0E0E0'
                />
                <path
                  d='M277.938 129.046C283.47 129.046 287.954 124.561 287.954 119.03C287.954 113.498 283.47 109.014 277.938 109.014C272.406 109.014 267.922 113.498 267.922 119.03C267.922 124.561 272.406 129.046 277.938 129.046Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M289.026 129.026C292.86 129.026 295.969 125.917 295.969 122.082C295.969 118.247 292.86 115.139 289.026 115.139C285.191 115.139 282.082 118.247 282.082 122.082C282.082 125.917 285.191 129.026 289.026 129.026Z'
                  fill='#EBEBEB'
                />
                <path
                  d='M201.312 300C287.539 300 357.44 295.919 357.44 290.885C357.44 285.851 287.539 281.77 201.312 281.77C115.084 281.77 45.1836 285.851 45.1836 290.885C45.1836 295.919 115.084 300 201.312 300Z'
                  fill='#F5F5F5'
                />
                <path
                  d='M101.547 228.441H204.975V281.838C204.975 283.22 204.426 284.545 203.449 285.522C202.472 286.499 201.147 287.048 199.765 287.048H106.762C106.077 287.048 105.399 286.914 104.767 286.653C104.134 286.391 103.559 286.007 103.075 285.524C102.59 285.04 102.206 284.465 101.944 283.833C101.682 283.2 101.547 282.522 101.547 281.838V228.441Z'
                  fill='#D1D3D4'
                />
                <path
                  d='M101.548 228.442H174.738L165.735 216.916C164.761 215.655 162.297 214.633 160.257 214.633H94.4389C92.4085 214.633 91.5563 215.655 92.5448 216.916L101.548 228.442Z'
                  fill='#D1D3D4'
                />
                <path
                  opacity='0.2'
                  d='M101.548 228.442H174.738L165.735 216.916C164.761 215.655 162.297 214.633 160.257 214.633H94.4389C92.4085 214.633 91.5563 215.655 92.5448 216.916L101.548 228.442Z'
                  fill='black'
                />
                <path
                  d='M204.978 228.441H131.793L140.796 220.927C141.77 220.119 144.234 219.438 146.274 219.438H212.082C214.118 219.438 214.965 220.105 213.976 220.927L204.978 228.441Z'
                  fill='#D1D3D4'
                />
                <path
                  opacity='0.2'
                  d='M131.793 228.178H204.978V281.559C204.978 282.244 204.843 282.921 204.581 283.553C204.32 284.185 203.936 284.76 203.452 285.244C202.968 285.727 202.394 286.111 201.762 286.373C201.13 286.635 200.452 286.77 199.768 286.77H137.003C136.319 286.77 135.641 286.635 135.009 286.373C134.377 286.111 133.803 285.727 133.319 285.244C132.835 284.76 132.451 284.185 132.19 283.553C131.928 282.921 131.793 282.244 131.793 281.559V228.178Z'
                  fill='white'
                />
                <path
                  opacity='0.5'
                  d='M110.629 228.441V265.063L113.161 263.067L114.938 265.063L116.487 262.838L118.074 265.063L120.28 263.398L122.71 265.063V228.441H110.629Z'
                  fill='white'
                />
                <path
                  d='M172.698 177.051L215.606 123.431L158.48 75.4688L120.631 118.912L114.997 129.771C114.458 130.366 114.176 131.151 114.214 131.953C114.253 132.755 114.608 133.51 115.202 134.051L115.372 134.192L166.908 177.47C167.748 178.143 168.812 178.473 169.885 178.396C170.959 178.318 171.963 177.838 172.698 177.051Z'
                  fill='#D1D3D4'
                />
                <path
                  opacity='0.5'
                  d='M143.277 137.518L137.098 147.465L139.586 148.006L140.433 150.304L142.084 150.402L142.848 152.374L144.869 152.963L146.422 155.436L152.601 145.493L143.277 137.518Z'
                  fill='white'
                />
                <path
                  opacity='0.1'
                  d='M213.735 121.796L175.258 164.713L120.605 118.83L158.479 75.4062L213.735 121.796Z'
                  fill='black'
                />
                <path
                  d='M213.735 121.873L175.258 164.791L191.185 165.969L229.068 122.54L213.735 121.873Z'
                  fill='#D1D3D4'
                />
                <path
                  opacity='0.3'
                  d='M213.735 121.873L175.258 164.791L191.185 165.969L229.068 122.54L213.735 121.873Z'
                  fill='black'
                />
                <path
                  d='M143.158 74.8066L104.676 117.734L120.608 118.912L158.481 75.4835L143.158 74.8066Z'
                  fill='#D1D3D4'
                />
                <path
                  opacity='0.4'
                  d='M143.158 74.8066L104.676 117.734L120.608 118.912L158.481 75.4835L143.158 74.8066Z'
                  fill='black'
                />
                <path
                  opacity='0.1'
                  d='M201.866 135.044L213.713 121.829L158.457 75.4395L151.387 92.477L201.866 135.044Z'
                  fill='black'
                />
                <path
                  opacity='0.2'
                  d='M120.605 118.911L158.479 75.4824L151.408 92.52L124.739 122.378L120.605 118.911Z'
                  fill='black'
                />
                <path
                  d='M244.988 44.5138C245.344 48.7792 246.395 56.5895 248.918 58.396C248.918 58.396 248.324 63.5234 239.257 64.8381C229.319 66.2988 233.779 60.6018 233.779 60.6018C239.004 58.508 238.274 54.5055 236.774 50.8633L240.606 46.481C242.081 44.84 244.793 42.3275 244.988 44.5138Z'
                  fill='#F9B499'
                />
                <path
                  d='M252.166 60.4804C252.969 59.7452 251.357 56.8188 250.369 56.4049C247.774 55.319 237.168 56.4049 233.185 59.8133C232.853 60.3793 232.652 61.0126 232.597 61.6666C232.543 62.3206 232.635 62.9786 232.869 63.5919L252.166 60.4804Z'
                  fill='#9E77ED'
                />
                <path
                  opacity='0.2'
                  d='M252.166 60.4804C252.969 59.7452 251.357 56.8188 250.369 56.4049C247.774 55.319 237.168 56.4049 233.185 59.8133C232.853 60.3793 232.652 61.0126 232.597 61.6666C232.543 62.3206 232.635 62.9786 232.869 63.5919L252.166 60.4804Z'
                  fill='black'
                />
                <path
                  d='M248.162 284.028H241.438L240.766 268.471H247.49L248.162 284.028Z'
                  fill='#F9B499'
                />
                <path
                  d='M295.387 273.404L289.193 275.536L282.766 260.875L288.959 258.742L295.387 273.404Z'
                  fill='#F9B499'
                />
                <path
                  d='M287.718 274.003L294.969 271.788C295.096 271.748 295.234 271.754 295.358 271.804C295.482 271.853 295.585 271.944 295.65 272.06L298.674 277.358C298.74 277.471 298.782 277.597 298.798 277.727C298.815 277.856 298.804 277.988 298.769 278.114C298.733 278.24 298.672 278.357 298.589 278.459C298.507 278.561 298.405 278.645 298.289 278.707C298.226 278.746 298.157 278.775 298.085 278.794C295.548 279.525 294.282 279.768 291.112 280.742C289.164 281.336 284.227 283.206 281.447 283.761C278.666 284.316 277.775 281.658 278.856 281.185C283.687 279.048 285.673 276.628 286.818 274.743C287.017 274.395 287.338 274.132 287.718 274.003Z'
                  fill='#9E77ED'
                />
                <path
                  d='M241.485 283.244H248.819C248.951 283.247 249.08 283.293 249.183 283.376C249.287 283.458 249.361 283.573 249.393 283.702L250.722 289.676C250.751 289.801 250.755 289.931 250.734 290.057C250.712 290.184 250.666 290.305 250.598 290.414C250.529 290.522 250.44 290.616 250.335 290.69C250.231 290.764 250.112 290.817 249.987 290.845C249.91 290.854 249.831 290.854 249.753 290.845C247.105 290.806 243.311 290.645 239.952 290.645C236.056 290.645 234.43 290.86 229.863 290.86C227.111 290.86 226.347 288.074 227.496 287.816C232.755 286.667 235.326 286.545 239.864 283.746C240.349 283.434 240.909 283.26 241.485 283.244Z'
                  fill='#9E77ED'
                />
                <path
                  d='M261.013 62.6777C262.961 64.4745 264.66 66.2712 266.418 68.1459C268.176 70.0206 269.797 71.9634 271.375 74.0328C273.024 76.1354 274.522 78.3533 275.854 80.6696C276.582 81.9463 277.212 83.2761 277.739 84.6478C277.875 85.0276 278.012 85.388 278.124 85.797C278.256 86.213 278.366 86.6356 278.455 87.063L278.591 87.7301L278.688 88.4702C278.781 89.1488 278.781 89.8367 278.688 90.5153C278.504 91.7976 278.032 93.0214 277.306 94.0942C276.774 94.8762 276.151 95.5922 275.45 96.2269C274.324 97.2481 273.094 98.1474 271.779 98.9099C269.462 100.234 267.038 101.363 264.533 102.284C259.779 104.048 254.88 105.394 249.892 106.306L248.484 101.476C252.867 99.5867 257.283 97.5416 261.368 95.3553C263.359 94.3163 265.275 93.1417 267.104 91.8397C267.864 91.2996 268.562 90.6792 269.188 89.9894C269.384 89.7857 269.548 89.5544 269.675 89.3028C269.744 89.1665 269.675 89.1811 269.597 89.4733C269.539 90.0138 269.549 89.595 269.422 89.3028C269.378 89.1665 269.305 88.9815 269.237 88.8159C269.169 88.6504 269.072 88.4361 268.984 88.2413C268.548 87.3629 268.06 86.5109 267.523 85.6899C266.279 83.8437 264.935 82.067 263.496 80.3678C262.036 78.61 260.453 76.8619 258.851 75.1479C257.249 73.4339 255.564 71.7005 254.021 70.1082L261.013 62.6777Z'
                  fill='#F9B499'
                />
                <path
                  d='M250.33 100.711L244 102.629L248.076 109.33C248.076 109.33 251.82 107.781 252.648 104.601L250.33 100.711Z'
                  fill='#FFC3BD'
                />
                <path
                  d='M241.426 105L243.924 110.527L248.024 109.334L243.948 102.629L241.426 105Z'
                  fill='#FFC3BD'
                />
                <path
                  d='M246.164 64.4991C245.56 70.9411 259.184 80.9134 259.184 80.9134L272.302 71.9344C270.026 67.7269 266.695 64.1831 262.637 61.6506C255.114 56.8495 246.919 56.494 246.164 64.4991Z'
                  fill='#9E77ED'
                />
                <path
                  d='M223.859 63.982C223.859 63.982 217.972 73.0193 231.952 121.478L267.498 116.229C267.011 111.316 261.056 89.8864 260.856 66.4653C260.839 64.2445 259.942 62.1211 258.36 60.5617C256.779 59.0023 254.643 58.1344 252.422 58.1486C252.296 58.1486 252.169 58.1486 252.047 58.1486C251.015 58.2022 249.954 58.2752 248.897 58.3823C243.827 58.8356 238.787 59.5802 233.802 60.6125C230.406 61.4771 227.082 62.6036 223.859 63.982Z'
                  fill='#9E77ED'
                />
                <path
                  opacity='0.2'
                  d='M222.988 79.5582L223.11 79.4219L231.466 80.1523C232.741 85.5474 228.086 92.9049 225.623 96.3182C224.446 90.7826 223.566 85.1879 222.988 79.5582Z'
                  fill='black'
                />
                <path
                  d='M244.559 119.618C244.559 119.618 250.329 168.7 254.511 187.928C259.093 208.993 281.711 266.421 281.711 266.421L292.988 262.525C292.988 262.525 278.492 219.282 274.646 189.837C271.69 167.224 267.478 116.229 267.478 116.229L244.559 119.618Z'
                  fill='#2F2E41'
                />
                <path
                  d='M278.813 262.818C278.76 262.818 281.126 267.648 281.126 267.648L294.273 263.373L292.725 259.443L278.813 262.818Z'
                  fill='#2F2E41'
                />
                <path
                  opacity='0.3'
                  d='M247.742 144.797C249.544 158.431 251.857 174.592 253.882 184.91C256.877 169.099 257.573 149.14 247.742 144.797Z'
                  fill='black'
                />
                <path
                  d='M231.952 121.478C231.952 121.478 227.166 167.585 227.925 188.075C228.68 209.378 238.638 274.942 238.638 274.942H250.012C250.012 274.942 247.919 210.619 248.401 189.701C248.956 166.889 257.511 117.699 257.511 117.699L231.952 121.478Z'
                  fill='#2F2E41'
                />
                <path
                  d='M236.428 270.41C236.38 270.41 237.071 275.128 237.071 275.128H250.914L251.289 270.917L236.428 270.41Z'
                  fill='#2F2E41'
                />
                <path
                  d='M229.746 75.309C228.49 77.3054 227.214 79.0973 225.895 80.9427C224.575 82.7882 223.187 84.5654 221.78 86.3379C218.907 89.931 215.795 93.3261 212.465 96.5C211.56 97.3083 210.732 98.1117 209.758 98.8421L209.047 99.4167L208.697 99.6991C208.565 99.8014 208.511 99.8598 208.244 100.05C207.446 100.62 206.57 101.071 205.643 101.389C204.207 101.879 202.705 102.15 201.188 102.192C199.907 102.237 198.624 102.182 197.351 102.027C192.694 101.414 188.151 100.128 183.863 98.2091L185.256 93.3788C189.376 93.8663 193.525 94.0649 197.673 93.9729C198.59 93.925 199.503 93.8258 200.409 93.6758C201.086 93.5733 201.743 93.3663 202.357 93.0623C202.552 92.9601 202.659 92.8529 202.634 92.8286C202.61 92.8042 202.737 92.7263 202.81 92.6533L203.082 92.4001L203.623 91.9132C204.348 91.2704 205.035 90.4913 205.741 89.7804C207.133 88.2807 208.521 86.7469 209.831 85.1108C211.141 83.4747 212.475 81.8338 213.761 80.1393C215.046 78.4448 216.297 76.7308 217.554 75.0217C218.81 73.3126 220.032 71.5012 221.196 69.8359L229.746 75.309Z'
                  fill='#F9B499'
                />
                <path
                  d='M234.422 73.1698C237.129 82.027 221.421 91.8434 221.421 91.8434L211.195 78.8425C213.499 74.5501 216.345 70.5717 219.663 67.0053C226.611 59.4483 232.362 66.4308 234.422 73.1698Z'
                  fill='#9E77ED'
                />
                <path
                  d='M187.621 93.6745L179.344 92.1602L180.215 99.3082C180.215 99.3082 184.515 101.743 187.631 97.9497L187.621 93.6745Z'
                  fill='#F9B499'
                />
                <path
                  d='M176.164 93.7719L177.951 98.9333L180.206 99.3082L179.334 92.1602L176.164 93.7719Z'
                  fill='#F9B499'
                />
                <path
                  d='M237.887 54.9935C237.88 54.6146 237.832 54.2377 237.746 53.8687C237.746 53.8687 241.223 53.4889 242.873 51.5996C242.849 51.5996 242.357 54.0245 237.887 54.9935Z'
                  fill='#F7A48B'
                />
                <path
                  d='M244.111 34.8689C245.572 41.3645 246.785 45.0943 244.52 49.3598C241.112 55.7142 232.376 55.1055 228.987 49.1748C225.934 43.8186 224.021 34.1093 229.528 29.7318C230.735 28.7629 232.169 28.118 233.695 27.8579C235.221 27.5978 236.788 27.7312 238.248 28.2455C239.708 28.7598 241.013 29.6379 242.039 30.7969C243.064 31.9558 243.778 33.3573 244.111 34.8689Z'
                  fill='#F9B499'
                />
                <path
                  d='M231.07 41.2517L228.597 42.766L228.83 34.3081C227.237 34.3764 225.666 33.9215 224.355 33.0129C225.247 32.1608 239.163 27.2867 243.501 28.1436C243.954 27.9586 244.504 27.1211 244.504 27.1211C244.504 27.1211 244.67 28.1777 243.94 28.5819C244.47 28.4796 245.8 28.7377 246.17 29.5168C245.559 29.3496 244.911 29.3873 244.324 29.6239C244.324 29.6239 249.155 30.3543 247.441 37.0544C245.493 44.4362 246.155 48.6822 246.155 48.6822C246.155 48.6822 242.562 51.4577 239.436 50.9464C236.09 47.2604 231.275 42.8439 231.07 41.2517Z'
                  fill='#2F2E41'
                />
                <path
                  d='M226.322 32.3474C222.398 32.3474 220.99 30.4289 219.992 28.8172C222.811 28.5202 228.684 26.7088 233.037 26.3826C237.39 26.0563 242.172 26.8695 240.73 28.8172C239.289 30.7649 226.322 32.3474 226.322 32.3474Z'
                  fill='#2F2E41'
                />
                <path
                  d='M227.175 30.5984C223.952 30.1456 220.811 27.112 223.226 24.2051C224.122 26.3378 230.155 26.0895 234.426 25.1789C240.064 24.0054 243.969 25.9045 241.973 29.7463C240.897 31.8644 227.175 30.5984 227.175 30.5984Z'
                  fill='#2F2E41'
                />
                <path
                  d='M234.538 39.3288C234.996 40.9188 234.922 42.6147 234.329 44.1591C233.52 46.1799 231.733 45.7708 230.798 44.0228C229.995 42.411 229.381 39.4895 230.75 38.0287C232.118 36.5679 233.954 37.4201 234.538 39.3288Z'
                  fill='#F9B499'
                />
              </svg>
            </div>
            <div className='not-found-msg'>
              <p style={{ fontWeight: 'bold' }}>
                {i18next.t('permission_denied.title')}
              </p>
              <ul
                style={{
                  textAlign: 'left',
                  color: '#6c757d',
                  fontSize: '12px',
                  padding: '20px',
                  maxWidth: '600px',
                  margin: 'auto',
                }}
              >
                {i18next
                  .t('permission_denied.reasons', { returnObjects: true })
                  .map((reason, index) => (
                    <li key={index}>
                      {reason.includes('log in again') ? (
                        <>
                          {reason.split('log in again')[0]}
                          <a
                            href='#'
                            onClick={(e) => {
                              e.preventDefault();
                              localStorage.clear();
                              window.location.href = '/';
                            }}
                            style={{ color: '#007bff', cursor: 'pointer' }}
                          >
                            log in again
                          </a>
                          .
                        </>
                      ) : (
                        reason
                      )}
                    </li>
                  ))}
              </ul>

              {/* <button
            type='submit'
            className='builder-btn active btn btn-primary'
            onClick={() => {
              window.location.href = '/';
            }}
          >
            {t('backToHomeBtn')}
          </button> */}
            </div>
          </section>
        </div>
      </section>

    </>
  );
};

export default UnAuthorized;
